import {Component} from '@angular/core';
import {WebsiteStatesService} from '../../website-states.service';
import {BreakpointConfig} from '../../website-states.enum';
import {LoanApplicationService} from '../../home/loan-application/loan-application.service';

@Component({
  selector: 'bb-top-banner',
  templateUrl: './top-banner.component.html',
  styleUrls: ['./top-banner.component.scss'],
})
export class TopBannerComponent {
  fontSize = this.website.viewport
    .map((config: BreakpointConfig) => {
      if (config.gteXSmall) {
        return '2em';
      }
      if (config.gteSmall) {
        return '3.5em';
      }
      return '5.44em';
    })
    .shareReplay(1);
  topPadding = this.website.viewport
    .map((config: BreakpointConfig) => {
      if (config.gteXSmall) {
        return '26px';
      }
      return '40px';
    })
    .shareReplay(1);

  isCebu = this.loan.routePrefix.map(p => p === 'cebu');

  constructor(private website: WebsiteStatesService,
              private loan: LoanApplicationService) {
  }
}
